import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@core/config/routes'

export const portfoliosRoutes: RouteRecordRaw[] = [
  {
    path: routes.INVESTOR_OVERVIEW,
    name: 'INVESTOR_OVERVIEW',
    component: () => import('./InvestorOverviewPage.vue'),
    meta: { requiresAuth: true, title: 'Investor & Portfolio Overview' },
  },
]
